// extracted by mini-css-extract-plugin
module.exports = {"root":"BreakingNewsAlert_root__vhYSw","hidden":"BreakingNewsAlert_hidden__Pe46j","alert":"BreakingNewsAlert_alert__7hlKe"};